"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LatticeGrid = _interopRequireDefault(require("./LatticeGrid"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var gridMainCols = 12;

function LatticeDevLines(_ref) {
  var maxRows = _ref.maxRows;

  var _ref2 = (0, _react.useState)(true),
      showGrid = _ref2[0],
      setShowGrid = _ref2[1];

  var toggleShowGrid = function toggleShowGrid() {
    setShowGrid(!showGrid);
  };

  var createGrid = function createGrid() {
    var grid = [];

    for (var i = 0; i < maxRows; i += 1) {
      var cols = [];

      for (var j = 0; j < gridMainCols; j += 1) {
        cols.push( /*#__PURE__*/_react.default.createElement("div", {
          key: "demo-mg-" + j
        }));
      }

      grid.push( /*#__PURE__*/_react.default.createElement("div", {
        key: "demo-f-" + i,
        className: "ltc__el ltc__el--f"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "ltc__g ltc__g--m"
      }, cols)));
    }

    return grid;
  };

  return /*#__PURE__*/_react.default.createElement(_LatticeGrid.default, {
    fullWidth: true,
    fullGrid: true,
    overlay: true,
    className: "ltc__dev"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: toggleShowGrid,
    onKeyDown: toggleShowGrid
  }, showGrid ? "Hide" : "Show"), /*#__PURE__*/_react.default.createElement("div", {
    className: "" + (showGrid ? "" : "hide")
  }, createGrid()));
}

LatticeDevLines.propTypes = {
  maxRows: _propTypes.default.number
};
LatticeDevLines.defaultProps = {
  maxRows: 500
};
LatticeDevLines.displayName = "LatticeDevLines";
var _default = LatticeDevLines;
exports.default = _default;